<template>
  <div class="page-call-guard">
    <div class="page-call-guard__content"></div>

    <div class="page-call-guard__aside"></div>
  </div>
</template>

<style lang="scss" scoped>
.page-call-guard {
  display: flex;
  height: 100%;
  padding: 0 8px 8px 0;
  gap: 8px;

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background-color: $color-primary-5;
    border-radius: 20px;
    padding: 20px;
  }

  &__aside {
    width: 358px;
    background-color: $color-primary-5;
    border-radius: 20px;
    padding: 20px;
  }
}
</style>
